import React, { Fragment } from 'react';
import { concat, filter, includes } from 'lodash';
import SearchBox from '../../../../../components/outline/SearchBox';
import BaseForm from '../../../../../components/form/BaseForm';
import ButtonList from '../../../../../components/ButtonList';
import { setQuickToDate } from '../../../../../lib/common';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import CheckBox from '../../../../../components/input/CheckBox';
import {
  ORDER_SEARCH_PERIOD_BUTTON_LIST,
  SEARCH_ORDER_CANCEL_STATUS_CHECK_BOX_LIST,
  SEARCH_ORDER_MANAGER_CHECK_BOX_LIST,
} from '../../../../../constants/service/app/orderConstants';
import {
  DATE_FORMAT,
  QUICK_DATE_SELECT_BUTTON_TARGET,
  SEARCH_PERIOD_BUTTON_ALL_TYPE,
} from '../../../../../constants/service/common/utilConstants';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import {
  ORDER_CANCEL_LIST_SEARCH_DATA_MODEL,
  ORDER_CANCEL_LIST_SEARCH_OPTION_MODEL,
} from '../../../../../store/modules/order/models';
import './OrderCancelListSearchBox.scss';

const OrderCancelListSearchBox = (props) => {
  const { setData, searchData, getList } = props;
  const { canceledDate, orderCancelStatusList, cancelAcceptManagerList, cancelManagerList } = searchData;

  return (
    <SearchBox
      className="order-cancel-list-search-box"
      onSearch={() => {
        /**
         * 날짜 선택 빠른 키 값이 전체가 아닌 경우에만 기간을 서버로 전송한다.
         * 날짜 선택이 전체인 경우 => quickDateIndex = -1
         */
        getList({
          searchOption: {
            /**
             *  취소 요청 일시
             */
            canceledDate: canceledDate.quickDateIndex !== SEARCH_PERIOD_BUTTON_ALL_TYPE ? canceledDate.period : null,
            /**
             *  주문 취소 상태 리스트
             */
            orderCancelStatusList,
            /**
             *  취소 접수자 리스트
             */
            cancelAcceptManagerList,
            /**
             *  취소 처리자 리스트
             */
            cancelManagerList,
          },
          pagination: LIST_PAGINATION_MODEL,
        });
      }}
      onClear={() => {
        getList({
          searchOption: ORDER_CANCEL_LIST_SEARCH_OPTION_MODEL,
          pagination: LIST_PAGINATION_MODEL,
        });
        setData({
          path: [],
          value: ORDER_CANCEL_LIST_SEARCH_DATA_MODEL,
        });
      }}
    >
      {/*취소 요청 일시*/}
      <BaseForm
        label="취소 요청 일시"
        content={
          <div className="quick-date-picker">
            {/*날짜 선택 빠른 키*/}
            <ButtonList
              current={canceledDate.quickDateIndex}
              list={ORDER_SEARCH_PERIOD_BUTTON_LIST}
              onClick={(data) =>
                setData({
                  path: ['canceledDate'],
                  value: setQuickToDate({
                    id: data.id,
                    value: data.value,
                    target: QUICK_DATE_SELECT_BUTTON_TARGET.START_DATE,
                    period: canceledDate.period,
                  }),
                })
              }
            />

            {/*날짜 선택*/}
            <DateRangePicker
              value={canceledDate.period}
              outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
              onSelect={(period) =>
                setData({
                  path: ['canceledDate'],
                  value: setQuickToDate({
                    period,
                  }),
                })
              }
            />
          </div>
        }
      />

      {/*취소 상태*/}
      <BaseForm
        label="취소 상태"
        content={
          <Fragment>
            {SEARCH_ORDER_CANCEL_STATUS_CHECK_BOX_LIST.map((item) => (
              <CheckBox
                key={item.id}
                checked={includes(orderCancelStatusList, item.id)}
                text={item.name}
                onChange={(checked) =>
                  setData({
                    path: ['orderCancelStatusList'],
                    value: checked
                      ? concat(orderCancelStatusList, item.id)
                      : filter(orderCancelStatusList, (id) => id !== item.id),
                  })
                }
              />
            ))}
          </Fragment>
        }
      />

      {/*취소 접수자*/}
      <BaseForm
        label="취소 접수자"
        content={
          <Fragment>
            {SEARCH_ORDER_MANAGER_CHECK_BOX_LIST.map((item) => (
              <CheckBox
                key={item.id}
                checked={includes(cancelAcceptManagerList, item.id)}
                text={item.name}
                onChange={(checked) =>
                  setData({
                    path: ['cancelAcceptManagerList'],
                    value: checked
                      ? concat(cancelAcceptManagerList, item.id)
                      : filter(cancelAcceptManagerList, (id) => id !== item.id),
                  })
                }
              />
            ))}
          </Fragment>
        }
      />

      {/*취소 처리자*/}
      <BaseForm
        label="취소 처리자"
        content={
          <Fragment>
            {SEARCH_ORDER_MANAGER_CHECK_BOX_LIST.map((item) => (
              <CheckBox
                key={item.id}
                checked={includes(cancelManagerList, item.id)}
                text={item.name}
                onChange={(checked) =>
                  setData({
                    path: ['cancelManagerList'],
                    value: checked
                      ? concat(cancelManagerList, item.id)
                      : filter(cancelManagerList, (id) => id !== item.id),
                  })
                }
              />
            ))}
          </Fragment>
        }
      />
    </SearchBox>
  );
};

export default OrderCancelListSearchBox;
